import styled from 'styled-components';

export const Wrapper = styled.div`
    margin-bottom: 3px;
    text-align: initial;    
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
    font-size: 12.5px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.08;
    letter-spacing: normal;
    color: ${({ theme }) => theme.text.modalLabel};
    font-weight: 600;
    margin-bottom: 12px;
    opacity: ${(props) => (props.disabled ? '0.3' : '1')};
`;
Title.displayName = 'Title';

export const CustomInput = styled.input`
    width: ${(props) => (props.width ? `${props.width}` : '224px')};
    height: ${(props) => (props.height ? `${props.height}` : '38px')};
    border: 1px solid transparent;
    border-bottom: ${(props) => (props.error ? '1px solid red' : 'none')};
    background-color: ${({ theme }) => theme.textfield.background} !important;
    padding-left: 15px;
    padding-right: 15px;
    font-size: 14.5px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.48;
    letter-spacing: normal;
    color: ${({ theme }) => theme.textfield.text};
    margin-top:13;

    &.full{
      background-color: ${({ theme }) => theme.textfield.focus}; 
    }

    &::placeholder {
      color: ${({ theme }) => theme.text.placeholder};
      font-size: 13.5px;
      font-weight: 300;
    }

    &:hover{
      border-style: solid;
      border-width: 1px 1px 0px 1px;
    }

    &:focus{
        background-color: ${({ theme }) => theme.textfield.focus};        

        &::placeholder {
            color: transparent;
        }
    }

    &:-webkit-autofill {
      background-color: ${({ theme }) => theme.textfield.background} !important;
      color: ${({ theme }) => theme.textfield.text} !important;
      box-shadow: 0 0 0px 1000px ${({ theme }) => theme.textfield.background} inset !important;
      -webkit-text-fill-color: ${({ theme }) => theme.textfield.text} !important; /* Evitar el cambio de color del texto */
      border: none !important;
    }

`;
CustomInput.displayName = 'CustomInput';
